import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RecordModel } from '@app/layout/record-model';
import * as Handlebars from 'handlebars';

/**
 * Angular pipe that parses a Handlebars template string and returns sanitized HTML.
 *
 * Usage in a template:
 * ```html
 * <div [innerHTML]="htmlTemplate | parseHandlebars: context"></div>
 * ```
 *
 * Where `htmlTemplate` contains Handlebars placeholders like `{{name}}` and
 * `context` is an object with the data to interpolate.
 */
@Pipe({
  name: 'parseHandlebars',
  pure: true // re‑evaluate when context object changes
})
export class ParseHandlebarsPipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) {}

  /**
   * Transforms a Handlebars template into sanitized SafeHtml.
   *
   * @param htmlTemplate  The Handlebars template string (may contain HTML).
   * @param context       Optional context object supplying values for placeholders.
   * @returns SafeHtml    Sanitized HTML marked as safe for binding with [innerHTML].
   */
  transform(htmlTemplate: string, context: any, categoryId: string): SafeHtml {
    if (!htmlTemplate) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    try {
      // Compile and render the Handlebars template
      const templateFn = Handlebars.compile(htmlTemplate);
      if(categoryId != null) {
        context = (context as RecordModel).Categories.find(category => category.Id === categoryId).Lines[0];
      }

      const renderedHtml: string = templateFn(context);

      // Sanitize the rendered HTML to strip any malicious content
      //const sanitizedHtml =
      //  this.sanitizer.sanitize(SecurityContext.HTML, renderedHtml) ?? '';

      // Mark the sanitized HTML as trusted so it can be bound via [innerHTML]
      return this.sanitizer.bypassSecurityTrustHtml(renderedHtml);
    } catch (err) {
      // console.error('[ParseHandlebarsPipe] Template compilation error:', err);
      // Fallback: return the raw template as safe HTML to avoid breaking the view
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
  }
}
